import { RuleEngineEntities } from '@bimser/components/dist/BCRuleManager';
import { call } from 'redux-saga/effects';
import { ICheckRules } from '../../../entities/ICheckRules';
import { runAction } from '../action';

export function* triggerAction(
	actions: Array<RuleEngineEntities.IAction>,
	args: ICheckRules<RuleEngineEntities.IRule, RuleEngineEntities.Rule>
) {
	const actionPromiseResults = yield call(runAction, {
		actions,
		rule: args.rule,
		checkType: args.checkType,
		windowId: args.windowId,
		validate: args.validate
	});
	return !!actionPromiseResults.filter(Boolean).length;
}
